<template>
  <div class="gift-details app-container">
    <div class="global-header-wrap">
      <h3>
        {{this.$route.query.title}}
      </h3>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="addCode">
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :currentPage="params.page"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination :pageSize="params.limit" :current-page="params.page" :total="total" @pageNum="pageNum" />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["appendPopup", "userInfo"]),
    tableProps() {
      let tableProps = [
        {
          prop: "content",
          label: "内容"
        },
        {
          width: 200,
          prop: "poetryDetailsHandle",
          label: this.$t("org.manage")
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      gift: {
        code: "",
        phone: "",
        password: "",
        verifyCode: ""
      },
      cardTitle: '',
      params: {
        limit: 20,
        page: localStorage.getItem('page')?parseInt(localStorage.getItem('page')):1,
        type: this.$route.query.type
      },
      codesFlag: false,
      tableData: [],
      total: 0,
      title: "",
      giftCodeItem: null,
      rules: {
      }
    };
  },

  created() {
  },

  methods: {

    getList() {
      if (localStorage.getItem('page')) {
        this.params.page = parseInt(localStorage.getItem('page'))
      }
      this.$http.getMottoDetails(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    addCode() {
      this.$router.push({ name: "createMottoDetail", query: { type: this.$route.query.type }});
    },

    codeEvn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === "新增") {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    edit(data) {
      this.$router.push({ name: "createMottoDetail", query: { id: data.row._id } });
    },

    toDetails(data) {
      this.giftCodeItem = data.row;
    },

    del(data) {
      this.$http.delMottoItem({_id: data.row._id}).then(res => {
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        }).catch(err => {
          this.elMsg(err.response.data.message, "error");
        })
    },
    pageNum(page) {
      this.params.page = page;
      localStorage.setItem('page', page)
      this.getList();
    },

    closeDialog() {
      this.codesFlag = false
      for (let i in this.gift) {
        this.gift[i] = "";
      }
    }
  },
  mounted() {},
  beforeDestroy() {
    // localStorage.removeItem('page')
  }
};
</script>

<style lang="scss" scoped>
.gift-details-header {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    // margin-right:10px;
  }
}
.gift-details-pagination {
  padding: 10px;
  text-align: right;
}
.gift-import-btn {
  margin-top: 10px;
}
.gift-mgt-fileName {
  margin-right: 10px;
}
.hand-add-btn {
  background-color: #56a3fd;
  border-radius: 3px;
  padding: 0px 12px;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  &:hover {
    background-color: #5bbbff;
  }
}
</style>
